export default __webpack_public_path__ + "159a279c37f78d848cdfbb579a6e4dbf.png";